export {
  StatColumn,
  StatColumns,
  type StatColumnProps,
  type StatColumnsProps,
} from './StatColumns';
